<template>
  <div class="application">
    <AppHeader justify-space-between/>

    <AppNotificationBar>
      Application Successful. Confirmation Number: {{ confirmationNumber }}
    </AppNotificationBar>

    <div class="application__content">
      <!-- step content goes here -->
      <StepHandlerDocuments/>
    </div>
    <AppFooter/>

    <AppCookieManager/>
  </div>
</template>

<script>
import AppNotificationBar from '@/components/common/notifications/AppNotificationBar'
import AppCookieManager from '@/components/common/hidden-fields/AppCookieManager'
import AppFooter from '@/components/common/layout/AppFooter'
import AppHeader from '@/components/common/layout/AppHeader'
import StepHandlerDocuments from './StepHandlerDocuments'
import confirmationNumber from '@/mixins/confirmation-number'

export default {
  // Name
  name: 'documents',

  // Components
  components: {
    AppNotificationBar,
    AppCookieManager,
    AppFooter,
    AppHeader,
    StepHandlerDocuments
  },

  // Mixins
  mixins: [confirmationNumber],

  mounted () {
    window.scrollTo(0, 0)
  }

  // Data
  // data () {
  //   return {
  //     variation: 'v2'
  //   }
  // }
}
</script>

<style scoped lang="scss">
.application {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  &__content {
    position: relative;
    min-height: 75vh;
  }
}
</style>
